export const MAX_CARD_W = 450; // px
export const MAX_CARD_H = 780; // px
export const ENDCARD_FEED_MSG = "இன்றைய அண்மைச் செய்திகளை அறிந்துகொண்டீர்கள்.";
export const ENDCARD_VIDEO_MSG =
  "நீங்கள் அனைத்து அண்மை வீடியோக்களையும் பார்த்துவிட்டீர்கள்.";
export const QN_SOCIAL_ICON_LIST = ["whatsapp", "facebook", "x", "copylink"];

export const QN_VIDEO_COUNT_PER_PAGE = 5;
export const QN_ARTICLE_COUNT_PER_PAGE = 5;
export const QN_GALLERY_COUNT_PER_PAGE = 1;

export const EXCLUDED_SECTIONS = [
  "baalar-murasu",
  "events",
  "horoscope-daily",
  "horoscope-weekly",
  "moe",
  "photo-gallery",
  "remedy",
  "tm-picks",
];

export const QN_ANALYTICS_EVENT_BASE = {
  event: "customEvent",
  eventCategory: "quick-news",
} as const;

export const PHOTO_DRAG_THRESHOLD = 30;

export const CAROUSEL_TRANSITION_DURATION = "0.8s";
export const CAROUSEL_TRANSITION_EASING =
  "cubic-bezier(0.175, 0.885, 0.32, 1.275)";
